import React, { Component } from 'react'
import { connect } from 'react-redux'

import Section from 'components/Section'
import Employment from './Employment'
import Rent from './Rent'

import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		application: doc(state, props.applicationID)
	})
)

export class PrimaryResident extends Component{
	render(){
		let { props } = this
		let resident = props.application.primaryResident
		return(
			<Section
				id="primaryResident"
				title={`Primary resident: ${resident.firstName} ${resident.lastName && resident.lastName[0]}`}
				top={true}
			>
				<div className="primary-resident" style={{paddingLeft: "30px"}}>
					<div className="age">
						<p>Age: {resident.age}</p>
					</div>
					<Employment data={resident.employment} />
					<Rent data={resident.rentalHistory}/>
				</div>
			</Section>
		)
	}
}
export default connect(select)(PrimaryResident)



// WEBPACK FOOTER //
// ./src/routes/landlord/applicationForm/PrimaryResident.js